import React from 'react';
import { ListDoctorsResponseElement } from '../../../types/apiGeneratedTypes';
import { specNames } from '../../../utils/constants';
import TableRowActionMenu from '../../BaseComponents/TableRowActionMenu';
import { useDispatch } from 'react-redux';
import {
  changeModalVisibility,
  setDoctorDataToEdit,
  setDoctorsList
} from '../../../store/doctorsSlice';
import {
  activateDoctor,
  deactivateDoctor,
  getDoctorsList
} from '../../../api/doctors';
import { toast } from 'react-toastify';
import './DoctorsTable.scss';

type Props = {
  doctorData: ListDoctorsResponseElement;
};

const DoctorsTableRow = ({ doctorData }: Props) => {
  const dispatch = useDispatch();

  const onOptionClick = async (id: string, action: string) => {
    if (action === 'edit') {
      dispatch(setDoctorDataToEdit(doctorData));
      dispatch(changeModalVisibility(true));
    } else if (action === 'toggle') {
      try {
        if (doctorData.is_active) {
          await deactivateDoctor(id);
          toast.success('Doctor deactivated successfully');
        } else {
          await activateDoctor(id);
          toast.success('Doctor activated successfully');
        }
        const updatedList = await getDoctorsList(0, 1000);
        dispatch(setDoctorsList(updatedList.doctors));
      } catch (error: any) {
        console.error('Error toggling doctor status:', error);
        if (error?.response?.data?.detail === 'Method Not Allowed') {
          toast.error('Method Not Allowed');
        } else {
          toast.error('Error updating doctor status');
        }
      }
    }
  };

  return (
    <div className={`table-row ${!doctorData.is_active ? 'disabled' : ''}`}>
      <div className='avatar'>
        <img src={doctorData.photo_url ?? ''} alt='' />
      </div>
      <div className='name'>{`${doctorData.last_name} ${doctorData.first_name}`}</div>
      <div className='url'>
        {doctorData.calendly_url ? (
          <a href={doctorData.calendly_url} target='_blank' rel='noreferrer'>
            {doctorData.calendly_url}
          </a>
        ) : null}
      </div>
      <div className='pre-scan-url'>
        {doctorData.pre_scan_consult_calendly_url ? (
          <a
            href={doctorData.pre_scan_consult_calendly_url}
            target='_blank'
            rel='noreferrer'
          >
            {doctorData.pre_scan_consult_calendly_url}
          </a>
        ) : null}
      </div>
      <div className='specialization'>
        {specNames[doctorData.specialization]}
      </div>
      <div className='team'>
        {doctorData.team_name || '-'}
      </div>
      <div className='bio'>{doctorData.bio}</div>
      <div className='contacts'>
        <span>{doctorData.email}</span> <span>{doctorData.phone}</span>
      </div>
      <div className='members'>
        <div className='table-count-cell'>{doctorData.members_count}</div>
      </div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            {
              key: 'toggle',
              value: doctorData.is_active ? 'Deactivate' : 'Activate'
            }
          ]}
          id={doctorData.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default DoctorsTableRow;
